module.exports = __webpack_public_path__ + "a5f56ace114b026f33460b447155136c.png";